export const STAGE_CLOSEOUT = 5;
export const STAGE_LOST = 6;
export const STAGE_ON_HOLD = 7;
